export const environment = {
  production: true,
  name: 'production',
  target: 'hosting',
  offline: false,
  emulators: {
    auth: false,
    firestore: false,
    storage: false,
    functions: false,
  },
  repairMode: true,
  firebase: {
    apiKey: 'AIzaSyD5kCr-7YX1yuXqjKdgCQbqIltHJPnETT8',
    authDomain: 'tokyo-concept-157620.firebaseapp.com',
    databaseURL: 'https://tokyo-concept-157620.firebaseio.com',
    projectId: 'tokyo-concept-157620',
    storageBucket: 'tokyo-concept-157620.appspot.com',
    messagingSenderId: '702728091037',
    appId: '1:702728091037:web:ab7c7f90c30947b1',
    measurementId: 'G-JZGTPSZQ3Q',
  },
  appConfig: {
    domain: '.damotech.com',
    faqUrlEn: 'https://www.damotech.com/en/knowledge/logging-in',
    faqUrlFr: 'https://www.damotech.com/fr/knowledge/ouvrir-une-session',
    helpDeskUrl: 'https://www.damotech.com/knowledge/kb-tickets/new',
    websiteUrl: 'https://www.damotech.com',
    signupUrl: {
      en: 'https://www.damotech.com/software/watch-the-demo-video-lp',
      fr: 'https://www.damotech.com/fr/reserver-une-demo-de-la-plateforme-lp',
    },
    fns: 'https://platform.damotech.com/api',
    ngFnsOrigin: 'https://platform.damotech.com',
    production: {
      bucket: {
        drawings: 'prod-tokyo-concept-157620',
      },
      mesUrl: 'https://dam001-mes01',
      mesHealthCheckUrl: 'https://dam001-mes01:3000',
      pubSubPrefix: 'rk-',
    },
    watson: {
      bucket: {
        drawings: 'prod-tokyo-concept-157620',
        import: 'prod-tokyo-concept-157620',
        importWork: 'prod-imports-work',
      },
      layoutDebugInfos: false,
      maxDownloadChunkSize: 10,
      maxSyncingWarehouses: 5,
      minSyncingDelay: 3600,
      maxSyncEventReplay: 500,
      pubsub: {
        import: 'rk-imports',
      },
      useWebworkers: false,
      downloadPicturesOnSync: false,
      // SC-9665: historical warehouse state snapshots. Online-only; off in production.
      warehouseStateSnapshots: false,
      sectionLayoutMode: true,
    },
    storage: {
      enabled: true,
      bucket: 'division-storage',
    },
    upload: {
      maxFileSize: 2048 * 1024 * 1024,
    },
    router: {
      history: 100,
    },
    heartbeatUrl: 'https://firebasestorage.googleapis.com/v0/b/prod-tokyo-concept-157620/o/public%2Fhealthcheck.txt',
    hubspotPortalId: '4533819',
  },
  home: 'https://platform.damotech.com',
  recaptcha: {
    siteKey: '6Lc-ASUjAAAAACHi5ZcvUICAtkNDppaTZvqWNdoO',
  },
};
